import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  productFeature: {
    id: 'product_jp_hygiene_product_feature',
    defaultMessage: 'Product feature',
  },
  thoroughQualityCheck: {
    id: 'product_jp_hygiene_thorough_quality_check',
    defaultMessage: 'Thorough quality check in Japan',
  },
  introDescription: {
    id: 'product_jp_hygiene_intro_description',
    defaultMessage:
      'At Back Market, all products sold undergo strict quality checks in Japan. From inspection to cleaning, operation verification, and packaging/shipping, each process is carefully handled by specialized staff.',
  },
  step01Label: {
    id: 'product_jp_hygiene_step_01_label',
    defaultMessage: 'Step 01.',
  },
  step01Heading: {
    id: 'product_jp_hygiene_step_01_heading',
    defaultMessage: 'Strict inspection & check',
  },
  step01Content: {
    id: 'product_jp_hygiene_step_01_content',
    defaultMessage:
      'Battery, stability, and parts are thoroughly inspected. Only devices meeting standards proceed. All personal data is erased.',
  },
  step02Label: {
    id: 'product_jp_hygiene_step_02_label',
    defaultMessage: 'Step 02.',
  },
  step02Heading: {
    id: 'product_jp_hygiene_step_02_heading',
    defaultMessage: 'Thorough cleaning',
  },
  step02Content: {
    id: 'product_jp_hygiene_step_02_content',
    defaultMessage:
      'Not only surface dirt, but also detailed areas such as terminals and speaker holes are carefully cleaned and kept in a hygienic condition.',
  },
  step03Label: {
    id: 'product_jp_hygiene_step_03_label',
    defaultMessage: 'Step 03.',
  },
  step03Heading: {
    id: 'product_jp_hygiene_step_03_heading',
    defaultMessage: 'Function & operation check',
  },
  step03Content: {
    id: 'product_jp_hygiene_step_03_content',
    defaultMessage:
      'Touch operation, camera, calls, buttons, sensors, etc. are individually verified. Parts are replaced and adjusted as needed to ensure a reliable, ready-to-use condition.',
  },
  step04Label: {
    id: 'product_jp_hygiene_step_04_label',
    defaultMessage: 'Step 04.',
  },
  step04Heading: {
    id: 'product_jp_hygiene_step_04_heading',
    defaultMessage: 'Packaging & shipping',
  },
  step04Content: {
    id: 'product_jp_hygiene_step_04_content',
    defaultMessage:
      'After final cleaning, the product is carefully packed using damage-prevention materials and shipped to the customer.',
  },
} as Record<string, I18nDefinition>
